export default [
    {
        type:'premium', // พรีเมี่ยม
        expire:new Date(2011, 0, 1, 0, 0, 0, 0),
    },
    {
        type:'staff', // พนักงาน
        expire:new Date(2011, 0, 1, 0, 0, 0, 0),
    },
    {
        type:'member', // สมาชิก
        expire:new Date(2011, 0, 1, 0, 0, 0, 0),
    },
    {
        type:'warehouse', // คลังสินค้าขนาดใหญ่
        expire:new Date(2011, 0, 1, 0, 0, 0, 0),
    },
    {
        type:'delivery', // เดลิเวอรี่
        expire:new Date(2011, 0, 1, 0, 0, 0, 0),
    },
]